import { fromJS } from 'immutable';
import {
  UPDATE_CUSTOMER_TOUCH_FIELD,
  UPDATE_CUSTOMER_VALIDATE_FIELD,
  UPDATE_CUSTOMER_UPDATE_FIELD,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMERP_CLEAR_SUCCESS,
} from './constants';
import {
  isValidName,
  isValidEmail,
  isValidPhone,
  isValidLastName,
} from '../../utils/helpers';
import { contactFields } from './uiHelpers';

function isFieldValid(id, value) {
  switch (id) {
    case 'phone':
      return isValidPhone(value);

    case 'email': {
      return isValidEmail(value);
    }

    case 'adultsonly':
      return value === true;

    case 'lastName':
      return isValidLastName(value);

    default:
      return isValidName(value);
  }
}

const initialState = fromJS({
  fields: contactFields,
  isSuccess: false,
});

export default function updateCustomer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_CUSTOMER_TOUCH_FIELD: {
      const index = state.get('fields').findIndex(field => field.get('id') === action.payload);
      return state.setIn(['fields', index, 'touched'], true);
    }

    case UPDATE_CUSTOMER_VALIDATE_FIELD: {
      const index = state.get('fields').findIndex(field => field.get('id') === action.payload.id);
      const field = state.get('fields').get(index);
      const id = field.get('id');

      return state.setIn(
        ['fields', index, 'error'],
        !isFieldValid(id, field.get('value'))
      );
    }
    case UPDATE_CUSTOMER_UPDATE_FIELD: {
      const index = state.get('fields').findIndex(field => field.get('id') === action.payload.id);
      return state.withMutations(s => s.setIn(['fields', index, 'value'], action.payload.value));
    }
    case UPDATE_CUSTOMER_SUCCESS: {
      return state.set('isSuccess', true);
    }
    case UPDATE_CUSTOMERP_CLEAR_SUCCESS: {
      return state.set('isSuccess', false);
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/reducer.js